import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {IHistoryRecordViewModel} from "../../../services/gaming-history/models/record/history-record-view-model.interface";
import {HistoryRecordContainerBox} from "./boxes/history-record-container.box";
import {HistoryRecordHeaderComponent} from "./header/history-record-header.component";
import {GamingHistoryRecordContentComponent} from "./content/gaming-history-record-content.component";
import {CyClass} from "../../../../common/cy-classes";

interface GamingHistoryRecordComponentProps {
    record: IHistoryRecordViewModel;
    showMoreDetails: boolean;
}

export const HistoryRecordComponent = observer(
    class HistoryRecordComponent extends OrbitComponent<GamingHistoryRecordComponentProps> {

        render() {
            return (
                <HistoryRecordContainerBox className={CyClass('cy-gaming-history-record')}>
                    <HistoryRecordHeaderComponent record={this.props.record}/>
                    <GamingHistoryRecordContentComponent record={this.props.record} showMoreDetails={this.props.showMoreDetails}/>
                    {/*cy-history-more-details*/}
                </HistoryRecordContainerBox>
            );
        }
    }
);